export default __webpack_public_path__ + "static/main_mobile-4f676802b85036700461eae42a6de900.mp4";